export enum TransactionType {
  Quotation = 'Quotation',
  SalesOrder = 'Sales Order',
  DeliveryOrder = 'Delivery Order',
  SalesInvoice = 'Sales Invoice',
  SalesDebitNote = 'Sales Debit Note',
  SalesCreditNote = 'Sales Credit Note',
  CashSales = 'Cash Sales',
  CashSaleRefund = 'Cash Sale Refund',
  PurchaseRequisition = 'Purchase Requisition',
  PurchaseOrder = 'Purchase Order',
  GoodsReceivedNote = 'Goods Received Note',
  PurchaseInvoice = 'Purchase Invoice',
  PurchaseDebitNote = 'Purchase Debit Note',
  PurchaseReturn = 'Purchase Return',
  CashPurchases = 'Cash Purchases',
  CashPurchaseRefund = 'Cash Purchase Refund',
  StockAdjustment = 'Stock Adjustment',
  StockTransfer = 'Stock Transfer',
  StockIn = 'Stock In',
  StockOut = 'Stock Out'
}

// URL path segments to TransactionType mapping with context paths
export const URL_TO_TRANSACTION_TYPE_MAP: Record<string, TransactionType> = {
  'sale/qt': TransactionType.Quotation,
  'sale/so': TransactionType.SalesOrder,
  'sale/do': TransactionType.DeliveryOrder,
  'sale/inv': TransactionType.SalesInvoice,
  'sale/dn': TransactionType.SalesDebitNote,
  'sale/cn': TransactionType.SalesCreditNote,
  'sale/cs': TransactionType.CashSales,
  'sale/csr': TransactionType.CashSaleRefund,
  'purchase/pr': TransactionType.PurchaseRequisition,
  'purchase/po': TransactionType.PurchaseOrder,
  'purchase/grn': TransactionType.GoodsReceivedNote,
  'purchase/inv': TransactionType.PurchaseInvoice,
  'purchase/dn': TransactionType.PurchaseDebitNote,
  'purchase/cn': TransactionType.PurchaseReturn,
  'purchase/cp': TransactionType.CashPurchases,
  'purchase/cpf': TransactionType.CashPurchaseRefund,
  'stk/adj': TransactionType.StockAdjustment,
  'stk/transfer': TransactionType.StockTransfer,
  'stk/in': TransactionType.StockIn,
  'stk/out': TransactionType.StockOut
};

// TransactionType to URL mapping (reverse mapping for easier lookups)
export const TRANSACTION_TYPE_TO_URL_MAP: Record<TransactionType, string> = {
  [TransactionType.Quotation]: 'sale/qt',
  [TransactionType.SalesOrder]: 'sale/so',
  [TransactionType.DeliveryOrder]: 'sale/do',
  [TransactionType.SalesInvoice]: 'sale/inv',
  [TransactionType.SalesDebitNote]: 'sale/dn',
  [TransactionType.SalesCreditNote]: 'sale/cn',
  [TransactionType.CashSales]: 'sale/cs',
  [TransactionType.CashSaleRefund]: 'sale/csr',
  [TransactionType.PurchaseRequisition]: 'purchase/pr',
  [TransactionType.PurchaseOrder]: 'purchase/po',
  [TransactionType.GoodsReceivedNote]: 'purchase/grn',
  [TransactionType.PurchaseInvoice]: 'purchase/inv',
  [TransactionType.PurchaseDebitNote]: 'purchase/dn',
  [TransactionType.PurchaseReturn]: 'purchase/cn',
  [TransactionType.CashPurchases]: 'purchase/cp',
  [TransactionType.CashPurchaseRefund]: 'purchase/cpf',
  [TransactionType.StockAdjustment]: 'stk/adj',
  [TransactionType.StockTransfer]: 'stk/transfer',
  [TransactionType.StockIn]: 'stk/in',
  [TransactionType.StockOut]: 'stk/out'
};

export const ACL_TRANSACTION_TYPE_MAP: Record<TransactionType, string> = {
  [TransactionType.Quotation]: 'qt',
  [TransactionType.SalesOrder]: 'so',
  [TransactionType.DeliveryOrder]: 'do',
  [TransactionType.SalesInvoice]: 'sinv',
  [TransactionType.SalesDebitNote]: 'sdn',
  [TransactionType.SalesCreditNote]: 'scn',
  [TransactionType.CashSales]: 'cs',
  [TransactionType.CashSaleRefund]: 'csr',
  [TransactionType.PurchaseRequisition]: 'pr',
  [TransactionType.PurchaseOrder]: 'po',
  [TransactionType.GoodsReceivedNote]: 'grn',
  [TransactionType.PurchaseInvoice]: 'pinv',
  [TransactionType.PurchaseDebitNote]: 'pdn',
  [TransactionType.PurchaseReturn]: 'pcn',
  [TransactionType.CashPurchases]: 'cp',
  [TransactionType.CashPurchaseRefund]: 'cpf',
  [TransactionType.StockAdjustment]: 'stkadj',
  [TransactionType.StockTransfer]: 'stt',
  [TransactionType.StockIn]: 'sin',
  [TransactionType.StockOut]: 'sout'
};

export const STOCK_RELATED_TRANSACTIONS = [
  'qt', // Quotation
  'so', // Sales Order
  'do', // Delivery Order
  'sinv', // Sales Invoice
  'sdn', // Sales Debit Note
  'scn', // Sales Credit Note
  'cs', // Cash Sales
  'csr', // Cash Sale Refund
  'pr', // Purchase Requisition
  'po', // Purchase Order
  'grn', // Goods Received Note
  'pinv', // Purchase Invoice
  'pdn', // Purchase Debit Note
  'pcn', // Purchase Return
  'cp', // Cash Purchases
  'cpf', // Cash Purchase Refund
  'stkadj', // Stock Adjustment
  'stt', // Stock Transfer
  'sin', // Stock In
  'sout' // Stock Out
];
